/* ==========================================================================
   Tirupati Silver – theme scripts (no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || { settings: {}, strings: {}, routes: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var root = (T.routes.root || '/').replace(/\/?$/, '/');
  var rootUrl = root; // for blocks where `root` is an element

  function storage(key, value) {
    try {
      if (value === undefined) return JSON.parse(localStorage.getItem(key) || '[]');
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { return []; }
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var format = T.moneyFormat || '₹{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Header height (for sticky offsets) ---------- */
  function setHeaderHeight() {
    var h = $('.section-header');
    if (h) document.documentElement.style.setProperty('--header-height', h.offsetHeight + 'px');
  }
  window.addEventListener('resize', setHeaderHeight);

  /* ---------- Drawers ---------- */
  var lastFocus;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var focusable = d.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    return true;
  }
  function closeDrawers() {
    $$('[data-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      // Cart icon: on the cart page itself, follow the link instead.
      if (opener.dataset.drawerOpen === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      if (openDrawer(opener.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ---------- Modals (size guide) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var m = document.getElementById(opener.dataset.modalOpen);
      if (m && m.showModal) { e.preventDefault(); m.showModal(); }
      return;
    }
    if (e.target.closest('[data-modal-close]')) {
      var dlg = e.target.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Tabs ---------- */
  function activateTab(buttons, panels, key) {
    buttons.forEach(function (b) {
      var on = b.dataset.tab === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) { p.hidden = p.dataset.panel !== key; });
  }
  $$('[data-tabs]').forEach(function (wrap) {
    var buttons = $$('[data-tab]', wrap);
    var panels = $$('[data-panel]', wrap);
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { activateTab(buttons, panels, b.dataset.tab); });
    });
  });
  $$('[data-tabs-nav]').forEach(function (nav) {
    var id = nav.dataset.tabsNav;
    var buttons = $$('[data-tab]', nav);
    var panels = $$('[data-tabs-panels="' + id + '"] > [data-panel]');
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        activateTab(buttons, panels, b.dataset.tab);
        panels.forEach(function (p) { if (!p.hidden) initCarousel($('[data-carousel]', p)); });
      });
    });
  });

  /* ---------- Announcement rotator ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var slides = $$('[data-slide]', slider);
    var dots = $$('[data-slider-dot]', slider);
    if (slides.length < 2) return;
    var index = 0;
    var timer;
    var delay = parseInt(slider.dataset.autoplay, 10) * 1000;
    function go(n) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (n + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
    }
    function play() {
      clearInterval(timer);
      if (delay > 0) timer = setInterval(function () { go(index + 1); }, delay);
    }
    var prev = $('[data-slider-prev]', slider);
    var next = $('[data-slider-next]', slider);
    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.sliderDot, 10)); play(); });
    });
    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    });
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', play);
    play();
  });

  /* ---------- Product carousels ---------- */
  function initCarousel(c) {
    if (!c) return;
    var track = $('[data-carousel-track]', c);
    var prev = $('[data-carousel-prev]', c);
    var next = $('[data-carousel-next]', c);
    if (!track) return;
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (!c.dataset.ready) {
      c.dataset.ready = '1';
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9 }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9 }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
    update();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- Predictive search ---------- */
  $$('[data-predictive-search]').forEach(function (form) {
    var input = $('[data-predictive-input]', form);
    var results = $('[data-predictive-results]', form);
    var timer, controller;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.hidden = true; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('.predictive__inner');
            results.innerHTML = inner ? inner.outerHTML : '';
            results.hidden = !inner;
          })
          .catch(function () {});
      }, 250);
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) results.hidden = true;
    });
    input.addEventListener('focus', function () { if (results.innerHTML.trim()) results.hidden = false; });
  });

  /* ---------- Render product cards via Section Rendering API ---------- */
  function fetchCards(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=product-card-render')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return '';
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.card');
          return card ? card.outerHTML : '';
        })
        .catch(function () { return ''; });
    }));
  }

  /* ---------- Wishlist ---------- */
  var WL_KEY = 'stj_wishlist';
  function wishlist() { return storage(WL_KEY) || []; }
  function syncWishlistUI() {
    var list = wishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.handle) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var list = wishlist();
    var h = btn.dataset.handle;
    var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.unshift(h); toast('Added to wishlist ♥'); }
    storage(WL_KEY, list.slice(0, 100));
    syncWishlistUI();
    if (i > -1) {
      var page = $('[data-wishlist-page]');
      if (page) {
        var li = btn.closest('li');
        if (li && page.contains(li)) li.remove();
        if (!wishlist().length) $('[data-wishlist-empty]', page).hidden = false;
      }
    }
  });
  function renderWishlistPage() {
    var page = $('[data-wishlist-page]');
    if (!page) return;
    var grid = $('[data-wishlist-grid]', page);
    var empty = $('[data-wishlist-empty]', page);
    var list = wishlist();
    if (!list.length) { empty.hidden = false; return; }
    fetchCards(list).then(function (cards) {
      var html = cards.filter(Boolean).map(function (c) { return '<li>' + c + '</li>'; }).join('');
      grid.innerHTML = html;
      empty.hidden = !!html;
      syncWishlistUI();
    });
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'stj_recent';
  function trackRecentlyViewed() {
    var el = $('[data-product-section]');
    var json = el && $('[data-product-json]', el);
    if (!json) return;
    try {
      var handle = JSON.parse(json.textContent).handle;
      var list = (storage(RV_KEY) || []).filter(function (h) { return h !== handle; });
      list.unshift(handle);
      storage(RV_KEY, list.slice(0, 20));
    } catch (e) {}
  }
  function renderRecentlyViewed() {
    $$('[data-recently-viewed]').forEach(function (sec) {
      var exclude = sec.dataset.exclude;
      var limit = parseInt(sec.dataset.limit, 10) || 8;
      var list = (storage(RV_KEY) || []).filter(function (h) { return h !== exclude; }).slice(0, limit);
      if (!list.length) return;
      fetchCards(list).then(function (cards) {
        var html = cards.filter(Boolean).map(function (c) { return '<li class="carousel__item">' + c + '</li>'; }).join('');
        if (!html) return;
        $('[data-recent-grid]', sec).innerHTML = html;
        sec.hidden = false;
        initCarousel($('[data-carousel]', sec));
        syncWishlistUI();
      });
    });
  }

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  function replaceDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var current = $('#CartDrawer');
    if (fresh && current) {
      var wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
    }
  }
  function refreshCart(sections) {
    if (sections && sections['cart-drawer']) replaceDrawer(sections['cart-drawer']);
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    // "Buy it now" and other submitters are left alone
    if (e.submitter && e.submitter.name && e.submitter.name !== 'add' && !e.submitter.hasAttribute('data-sticky-add')) return;
    e.preventDefault();
    var btn = $('[data-add-to-cart]', form);
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) { toast(res.description || res.message || 'Could not add to cart'); return; }
        // Name engraving: add the engraving charge as its own line, linked to this design.
        var eng = $('[data-engraving]', form);
        var engToggle = eng && $('[data-engraving-toggle]', eng);
        var engText = eng && $('[data-engraving-text]', eng);
        var extra = Promise.resolve(null);
        if (engToggle && engToggle.checked && engText && engText.value.trim()) {
          var qtyInput = $('input[name="quantity"]', form);
          extra = fetch(T.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(eng.dataset.variant), quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1,
                        properties: { For: eng.dataset.productTitle, Text: engText.value.trim() } }],
              sections: ['cart-drawer'], sections_url: window.location.pathname
            })
          }).then(function (r) { return r.json(); }).catch(function () { return null; });
        }
        // Gift wrap ticked on the product page: add it once per order + save the message.
        var gift = $('[data-product-gift-wrap]', form);
        var giftToggle = gift && $('[data-product-gift-toggle]', gift);
        if (giftToggle && giftToggle.checked) {
          var giftMsg = $('[data-product-gift-message]', gift);
          extra = extra.then(function (prev) {
            return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var has = cart.items.some(function (it) { return String(it.variant_id) === String(gift.dataset.variant); });
              var jobs = [];
              if (giftMsg) {
                jobs.push(fetch(root + 'cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ attributes: { 'Gift message': giftMsg.value.trim() } })
                }));
              }
              return Promise.all(jobs).then(function () {
                if (has) return prev;
                return fetch(T.routes.cartAdd + '.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ items: [{ id: Number(gift.dataset.variant), quantity: 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
                }).then(function (r) { return r.json(); });
              });
            }).catch(function () { return prev; });
          });
        }
        return extra.then(function (res2) {
          return refreshCart((res2 && res2.sections) || res.sections);
        }).then(function () {
          openDrawer('CartDrawer');
        });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.dataset.cartQty, 10);
    var qty = Math.max(0, parseInt(btn.dataset.qtyValue, 10));
    var wrap = btn.closest('.cart-items');
    if (wrap) wrap.setAttribute('data-cart-loading', '');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) { toast(res.description || res.message); if (wrap) wrap.removeAttribute('data-cart-loading'); return; }
        if ($('[data-main-cart]')) { window.location.reload(); return; }
        refreshCart(res.sections);
      })
      .catch(function () { window.location.reload(); });
  });

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = $('input', (minus || plus).closest('[data-qty]'));
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-to-cart]', section);
    var addLabel = $('[data-add-label]', section);
    var stickyBtn = $('[data-sticky-add]', section);
    var stickyPrice = $('[data-sticky-price]', section);
    var gallery = $('[data-gallery-main]', section);
    var thumbs = $$('[data-thumb]', section);

    function currentOptions() {
      return $$('[data-option-index]', section).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }
    function markAvailability(opts) {
      $$('[data-option-index]', section).forEach(function (fs, idx) {
        $$('[data-option-input]', fs).forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var v = findVariant(test);
          input.closest('.swatch').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function scrollToMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var slide = $('[data-media-id="' + mediaId + '"]', gallery);
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
    }
    function update() {
      var opts = currentOptions();
      $$('[data-option-index]', section).forEach(function (fs, i) {
        var label = $('[data-option-selected]', fs);
        if (label) label.textContent = opts[i];
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = T.strings.unavailable || 'Unavailable';
        return;
      }
      idInput.value = v.id;
      section.dispatchEvent(new CustomEvent('stj:variant', { detail: v, bubbles: true }));
      var priceEl = $('[data-price]', section);
      var compareEl = $('[data-compare-price]', section);
      var offEl = $('[data-price-off]', section);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; }
      if (offEl) {
        offEl.hidden = !onSale;
        if (onSale) offEl.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF';
      }
      var sku = $('[data-sku]', section);
      if (sku) sku.textContent = v.sku ? 'SKU: ' + v.sku : '';
      var skuCell = $('[data-sku-cell]', section);
      if (skuCell) skuCell.textContent = v.sku || '';
      [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
      var notify = $('[data-notify-me]', section);
      if (notify) {
        notify.hidden = v.available && !$('.form-success', notify);
        var notifyVariant = $('[data-notify-variant]', notify);
        if (notifyVariant) notifyVariant.value = v.title;
      }
      if (addLabel) addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (v.featured_media) scrollToMedia(v.featured_media.id);
      updateBreakup(section, v.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('[data-option-input]', section).forEach(function (input) {
      input.addEventListener('change', update);
    });
    if (product.variants.length > 1) markAvailability(currentOptions());

    // Gallery thumbnails and active state
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = gallery.children[parseInt(t.dataset.thumb, 10)];
        if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      });
    });
    if (gallery && thumbs.length) {
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }
    // Click-to-zoom on desktop, follows the cursor
    $$('[data-zoom]', section).forEach(function (z) {
      z.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.matchMedia('(max-width: 989px)').matches) return;
        z.classList.toggle('is-zoomed');
        var img = $('img', z);
        if (!z.classList.contains('is-zoomed')) img.style.transformOrigin = '';
      });
      z.addEventListener('mousemove', function (e) {
        if (!z.classList.contains('is-zoomed')) return;
        var r = z.getBoundingClientRect();
        $('img', z).style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      z.addEventListener('mouseleave', function () { z.classList.remove('is-zoomed'); });
    });

    // Sticky add-to-cart on mobile once the main button scrolls away
    var sticky = $('[data-sticky-atc]', section);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }).observe(addBtn);
    }

    updateBreakup(section, idInput.value);
    if (form) form.setAttribute('data-ready', '');
  }

  function updateBreakup(section, variantId) {
    var wrap = $('[data-price-breakup]', section);
    if (!wrap) return;
    var data;
    try { data = JSON.parse($('[data-breakup-json]', wrap).textContent)[variantId]; } catch (e) { return; }
    if (!data) return;
    var rate = parseFloat(T.settings.silverRate) || 0;
    var gstPct = parseFloat(T.settings.gstPercent) || 0;
    var price = data.price; // in paise
    var weight = parseFloat(data.weight) || 0;
    var stones = Math.round((parseFloat(data.stones) || 0) * 100);
    var gst = Math.round(price * gstPct / (100 + gstPct));
    var mpg = parseFloat(data.mpg) || 0;
    var mk = parseFloat(data.mk) || 0;
    var metal, making, makingFull = 0, hasWeight;
    if (weight > 0 && (mpg > 0 || mk > 0)) {
      // Same making metafields as the Flow price update, so silver value is
      // whatever the price was set at – no daily rate needed.
      // festive offer: "making_discount" % off the making (the Flow price update uses the same field)
      var disc = Math.min(Math.max(parseFloat(T.settings.makingDiscount) || 0, 0), 90);
      makingFull = Math.round((weight * mpg + mk) * 100);
      making = Math.round(makingFull * (100 - disc) / 100);
      metal = Math.max(price - gst - stones - making, 0);
      hasWeight = true;
    } else {
      metal = Math.round(weight * rate * 100);
      hasWeight = weight > 0 && rate > 0;
      making = Math.max(price - gst - stones - (hasWeight ? metal : 0), 0);
    }
    function set(key, val) { var el = $('[data-breakup="' + key + '"]', wrap); if (el) el.textContent = val; }
    $$('[data-breakup-row="metal"]', wrap).forEach(function (r) { r.hidden = !hasWeight; });
    var stonesRow = $('[data-breakup-row="stones"]', wrap);
    if (stonesRow) stonesRow.hidden = stones <= 0;
    var makingLabel = $('[data-breakup-label="making"]', wrap);
    var off = makingFull > making ? Math.round((1 - making / makingFull) * 100) : 0;
    if (makingLabel) makingLabel.textContent = hasWeight ? 'Making charges' + (off ? ' (' + off + '% off)' : '') : 'Silver + making charges';
    set('weight', weight ? weight + ' g' : '–');
    set('metal', formatMoney(metal));
    set('stones', formatMoney(stones));
    set('making', formatMoney(making));
    var mEl = $('[data-breakup="making"]', wrap);
    if (mEl && off) mEl.innerHTML = '<s class="breakup__was">' + formatMoney(makingFull) + '</s> ' + formatMoney(making);
    set('gst', formatMoney(gst));
    set('total', formatMoney(price));
  }

  /* ---------- Pincode check ---------- */
  function addDays(n) {
    var d = new Date();
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // skip Sundays
    }
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  $$('[data-pincode]').forEach(function (box) {
    var form = $('[data-pincode-form]', box);
    var input = $('input', form);
    var out = $('[data-pincode-result]', box);
    try { var saved = localStorage.getItem('stj_pincode'); if (saved) input.value = saved; } catch (e) {}
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pin = input.value.trim();
      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        out.innerHTML = '<p class="err">Please enter a valid 6-digit pincode.</p>';
        return;
      }
      try { localStorage.setItem('stj_pincode', pin); } catch (err) {}
      var blocked = String(T.settings.pincodeBlocked || '').split(/[\s,]+/).filter(Boolean);
      if (blocked.indexOf(pin) > -1) {
        out.innerHTML = '<p class="err">Sorry, we do not deliver to ' + pin + ' yet. Please WhatsApp us for help.</p>';
        return;
      }
      var fast = String(T.settings.pincodeFastPrefixes || '').split(/[\s,]+/).filter(Boolean);
      var days = parseInt(T.settings.pincodeDays, 10) || 5;
      if (fast.some(function (p) { return pin.indexOf(p) === 0; })) days = 2;
      var price = 0;
      var jsonEl = document.querySelector('[data-product-json]');
      var idEl = document.querySelector('[data-variant-id]');
      if (jsonEl && idEl) {
        try {
          var p = JSON.parse(jsonEl.textContent);
          var v = p.variants.find(function (x) { return String(x.id) === String(idEl.value); });
          if (v) price = v.price / 100;
        } catch (err) {}
      }
      var codLimit = parseFloat(T.settings.codLimit) || 0;
      var cod = T.settings.codEnabled && (!codLimit || !price || price <= codLimit);
      out.innerHTML =
        '<ul>' +
        '<li class="ok">✓ Delivery by <strong>' + addDays(days) + '</strong> to ' + pin + '</li>' +
        '<li class="' + (cod ? 'ok' : 'err') + '">' + (cod ? '✓ Cash on Delivery available' : '✗ COD not available for this order value') + '</li>' +
        '<li class="ok">✓ Free shipping* & 10-day returns on damaged items</li>' +
        '</ul>';
      document.dispatchEvent(new CustomEvent('stj:pincode', { detail: { pincode: pin } }));
    });
  });

  /* ---------- Facets (filters & sorting) ---------- */
  function submitFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
    window.location.search = params.toString();
  }
  $$('[data-facets-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(form); });
    $$('[data-auto-submit]', form).forEach(function (el) {
      el.addEventListener('change', function () { submitFacets(form); });
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (sec) {
    if (sec.querySelector('.card')) return;
    fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        sec.innerHTML = fresh.innerHTML;
        initCarousel($('[data-carousel]', sec));
        syncWishlistUI();
      }
    }).catch(function () {});
  });

  /* ---------- Store locator city filter ---------- */
  $$('[data-store-filter]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      $$('[data-store-city]').forEach(function (s) {
        s.hidden = sel.value && s.dataset.storeCity !== sel.value;
      });
    });
  });

  /* ---------- Appointment form: prefill product/type, piercing questions ---------- */
  $$('[data-appointment-product]').forEach(function (input) {
    var p = new URLSearchParams(window.location.search).get('product');
    if (p) input.value = p;
  });
  $$('[data-appointment]').forEach(function (sec) {
    var select = $('[data-appointment-type]', sec);
    var fields = $('[data-piercing-fields]', sec);
    if (!select || !fields) return;
    var wanted = (new URLSearchParams(window.location.search).get('type') || '').toLowerCase();
    if (wanted) {
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.value.toLowerCase() === wanted) select.value = o.value;
      });
    }
    function toggle() {
      var show = sec.dataset.alwaysPiercing === 'true' || /pierc/i.test(select.value);
      fields.hidden = !show;
      fields.disabled = !show;
    }
    select.addEventListener('change', toggle);
    toggle();
  });

  /* ---------- Appointment form: reference number + booking summary ----------
     On submit we add a reference number (it is emailed with the booking) and
     keep the answers for this tab. After Shopify reloads the page with the
     success message, we show them as a small table to screenshot. */
  var BOOKING_KEY = 'stj_last_booking';
  function formatDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!m) return value;
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  }
  $$('form[data-booking-form]').forEach(function (form) {
    var refInput = $('[data-booking-ref]', form);
    if (refInput) {
      form.addEventListener('submit', function () {
        var now = new Date();
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var ref = (form.dataset.refPrefix || 'STJ') + '-' +
          String(now.getFullYear()).slice(2) + pad(now.getMonth() + 1) + pad(now.getDate()) + '-' +
          String(Math.floor(1000 + Math.random() * 9000));
        refInput.value = ref;
        var rows = [['Reference number', ref]];
        var all = [['Reference number', ref]];
        $$('[data-prop]', form).forEach(function (el) {
          if (el.disabled || el.closest('fieldset[disabled]')) return;
          var label = el.dataset.prop;
          var value = String(el.value || '').trim();
          if (!value) return;
          var pair = [label, label === 'Preferred date' ? formatDate(value) : value];
          all.push(pair); // WhatsApp message gets every answer
          if (label !== 'Message' && label !== 'Email') rows.push(pair); // the on-page table stays short
        });
        try { sessionStorage.setItem(BOOKING_KEY, JSON.stringify({ rows: rows, all: all, at: Date.now() })); } catch (e) {}
      });
    }

    var done = $('[data-booking-done]', form);
    if (!done) return;
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem(BOOKING_KEY) || 'null'); } catch (e) {}
    // Only show a booking made in this tab within the last hour.
    if (!data || !data.rows || Date.now() - data.at > 3600000) return;
    var tbody = $('[data-booking-rows]', done);
    data.rows.forEach(function (row) {
      var tr = document.createElement('tr');
      var th = document.createElement('th');
      var td = document.createElement('td');
      th.textContent = row[0];
      td.textContent = row[1];
      if (row[0] === 'Reference number') tr.className = 'booking-table__ref';
      tr.appendChild(th); tr.appendChild(td); tbody.appendChild(tr);
    });
    $('[data-booking-summary]', done).hidden = false;

    // "Send on WhatsApp": opens the customer's WhatsApp with the booking typed in.
    var wa = $('[data-booking-whatsapp]', done);
    if (wa && wa.dataset.number) {
      var lines = ['*New booking - ' + (wa.dataset.store || 'Website') + '*', ''];
      (data.all || data.rows).forEach(function (row) { lines.push(row[0] + ': ' + row[1]); });
      wa.href = 'https://wa.me/' + wa.dataset.number + '?text=' + encodeURIComponent(lines.join('\n'));
    }
    done.scrollIntoView({ block: 'start' });
  });

  /* ---------- Login / recover password toggle ---------- */
  // After signing in, go back to the page that asked for it (e.g. the Staff Portal)
  // instead of the account page. Shopify's login form reads a hidden return_to field.
  $$('form[action*="/account/login"]').forEach(function (form) {
    var p = new URLSearchParams(location.search);
    if (p.get('checkout_url')) return; // Shopify handles checkout logins itself
    var back = p.get('return_to') || p.get('return_url') || '';
    try { if (!back) back = sessionStorage.getItem('stj_return_to') || ''; } catch (e) {}
    if (!/^\/(?!\/)/.test(back)) return; // only paths on this site
    var input = form.querySelector('input[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.appendChild(input); }
    input.value = back;
  });

  $$('[data-login]').forEach(function (box) {
    var login = $('[data-login-form]', box);
    var recover = $('[data-recover-form]', box);
    function show(rec) { login.hidden = rec; recover.hidden = !rec; }
    if (window.location.hash === '#recover' || recover.querySelector('.form-success, .errors')) show(true);
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-show-recover]')) { e.preventDefault(); show(true); }
      if (e.target.closest('[data-hide-recover]')) { e.preventDefault(); show(false); }
    });
  });

  /* ---------- Address forms: preselect India ---------- */
  $$('select[name="address[country]"][data-default]').forEach(function (sel) {
    sel.value = sel.dataset.default;
  });

  /* ---------- Name engraving tick box ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-engraving-toggle]');
    if (!t) return;
    var box = t.closest('[data-engraving]');
    var fields = $('[data-engraving-fields]', box);
    var input = $('[data-engraving-text]', box);
    fields.hidden = !t.checked;
    input.disabled = !t.checked;
    input.required = t.checked;
    var form = box.closest('form');
    if (form) form.classList.toggle('has-engraving', t.checked); // hides "Buy it now"
    if (t.checked) input.focus();
  });

  /* ---------- Gift wrap tick box on the product page ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-product-gift-toggle]');
    if (!t) return;
    var fields = $('[data-product-gift-fields]', t.closest('[data-product-gift-wrap]'));
    if (fields) fields.hidden = !t.checked;
  });

  /* ---------- Gift wrap in the cart ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-gift-wrap-toggle]');
    if (!t) return;
    var box = t.closest('[data-gift-wrap]');
    box.classList.add('is-busy');
    var body = t.checked
      ? { url: T.routes.cartAdd + '.js', data: { items: [{ id: Number(box.dataset.variant), quantity: 1 }] } }
      : { url: T.routes.cartChange + '.js', data: { id: t.dataset.lineKey, quantity: 0 } };
    body.data.sections = ['cart-drawer'];
    body.data.sections_url = window.location.pathname;
    fetch(body.url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body.data) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if ($('[data-main-cart]') || (res.status && res.status >= 400)) { window.location.reload(); return; }
        refreshCart(res.sections);
      })
      .catch(function () { window.location.reload(); });
  });
  document.addEventListener('change', function (e) {
    var msg = e.target.closest('[data-gift-message]');
    if (!msg) return;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift message': msg.value.trim() } })
    }).then(function () { toast('Gift message saved'); }).catch(function () {});
  });

  /* ---------- Buy back / exchange calculator ---------- */
  $$('[data-buyback-calc]').forEach(function (form) {
    var purity = $('[data-calc-purity]', form);
    var custom = $('[data-calc-custom]', form);
    var result = $('[data-calc-result]', form);
    var error = $('[data-calc-error]', form);
    var inr = function (n) { return n.toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }); };
    var num = function (name) { return parseFloat((form.elements[name] || {}).value); };
    purity.addEventListener('change', function () { custom.hidden = purity.value !== 'custom'; });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var gross = num('gross');
      var stones = num('stones') || 0;
      var pct = purity.value === 'custom' ? num('custom_purity') : parseFloat(purity.value);
      var rate = num('rate');
      var problem = !(gross > 0) ? 'Please enter the total weight.' :
        stones < 0 || stones >= gross ? 'Stone and bead weight must be less than the total weight.' :
        !(pct > 0 && pct <= 100) ? 'Please enter a purity between 1 and 100%.' :
        !(rate > 0) ? "Please enter today's fine silver rate per gram." : '';
      error.hidden = !problem;
      error.textContent = problem;
      if (problem) { result.hidden = true; return; }
      var net = gross - stones;
      var pure = net * pct / 100;
      var set = function (key, val) { var el = $('[data-calc="' + key + '"]', form); if (el) el.textContent = val; };
      set('net', net.toFixed(3) + ' g');
      set('purity', pct + '%');
      set('pure', pure.toFixed(3) + ' g');
      set('rate', inr(rate) + ' / g');
      set('value', inr(Math.round(pure * rate)));
      result.hidden = false;
      result.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  });

  /* ---------- Video reels: autoplay in view, sound, full-screen viewer ---------- */
  var reelVideos = $$('.reel__video');
  var reelViewerOpen = false;
  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); return p; }
  reelVideos.forEach(function (v) {
    var item = v.closest('[data-reel]');
    var bar = item && $('[data-reel-progress]', item);
    v.muted = true;
    v.addEventListener('play', function () { if (item) item.classList.add('is-playing'); });
    v.addEventListener('pause', function () { if (item) item.classList.remove('is-playing'); });
    if (bar) v.addEventListener('timeupdate', function () {
      if (v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%';
    });
  });
  if (reelVideos.length && 'IntersectionObserver' in window) {
    var reelObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && !reelViewerOpen) playSafe(v);
        else v.pause();
      });
    }, { threshold: 0.6 });
    reelVideos.forEach(function (v) { reelObserver.observe(v); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reel-sound]');
    if (!btn) return;
    var video = $('.reel__video', btn.closest('.reel__media'));
    if (!video) return;
    var turnOn = video.muted;
    reelVideos.forEach(function (v) { v.muted = true; });
    $$('[data-reel-sound]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    video.muted = !turnOn;
    btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
    if (turnOn) playSafe(video);
  });

  $$('[data-reels]').forEach(function (section) {
    var viewer = $('[data-reel-viewer]', section);
    if (!viewer) return;
    var items = $$('[data-reel]', section).filter(function (li) { return $('.reel__video', li); });
    var stage = $('.reel-viewer__stage', viewer);
    var video = $('[data-reel-viewer-video]', viewer);
    var panel = $('[data-reel-viewer-panel]', viewer);
    var bars = $('[data-reel-bars]', viewer);
    var soundBtn = $('[data-reel-viewer-sound]', viewer);
    var share = $('[data-reel-share]', viewer);
    var prevBtn = $('[data-reel-prev]', viewer);
    var nextBtn = $('[data-reel-next]', viewer);
    var index = 0, returnFocus = null, wantSound = true;

    bars.innerHTML = items.map(function () { return '<span><i></i></span>'; }).join('');
    var barEls = $$('span', bars);

    function show(i) {
      index = i;
      var src = $('.reel__video', items[i]);
      video.innerHTML = '';
      $$('source', src).forEach(function (s) { video.appendChild(s.cloneNode()); });
      if (src.poster) video.poster = src.poster; else video.removeAttribute('poster');
      video.muted = !wantSound;
      video.load();
      var p = playSafe(video);
      // Browsers can block autoplay with sound; fall back to muted.
      if (p && p.catch) p.catch(function () { video.muted = true; syncSound(); playSafe(video); });
      syncSound();

      panel.innerHTML = '';
      var tpl = $('template[data-reel-panel]', items[i]);
      var title = document.title, url = window.location.href;
      if (tpl) {
        panel.appendChild(tpl.content.cloneNode(true));
        var t = $('[data-reel-share-title]', panel), u = $('[data-reel-share-url]', panel);
        if (t) title = t.textContent.trim();
        if (u) url = u.textContent.trim();
      }
      share.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);

      barEls.forEach(function (b, n) {
        b.classList.toggle('is-done', n < i);
        $('i', b).style.width = n < i ? '100%' : '0';
      });
      prevBtn.disabled = i === 0;
      nextBtn.disabled = i === items.length - 1;
    }
    function syncSound() { soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true'); }
    function open(i) {
      reelViewerOpen = true;
      reelVideos.forEach(function (v) { v.pause(); });
      returnFocus = document.activeElement;
      viewer.hidden = false;
      document.body.classList.add('is-locked');
      show(i);
      $('[data-reel-close].reel-viewer__tool', viewer).focus();
    }
    function close() {
      if (viewer.hidden) return;
      video.pause();
      video.innerHTML = '';
      video.removeAttribute('src');
      video.load();
      viewer.hidden = true;
      reelViewerOpen = false;
      document.body.classList.remove('is-locked');
      if (returnFocus) returnFocus.focus();
      if (items[index]) playSafe($('.reel__video', items[index]));
    }
    function go(step) {
      var n = index + step;
      if (n < 0) return;
      if (n >= items.length) { close(); return; }
      show(n);
    }

    items.forEach(function (li, i) {
      var openBtn = $('[data-reel-open]', li);
      if (openBtn) openBtn.addEventListener('click', function () { open(i); });
    });
    video.addEventListener('timeupdate', function () {
      if (video.duration && barEls[index]) $('i', barEls[index]).style.width = (video.currentTime / video.duration * 100) + '%';
    });
    video.addEventListener('ended', function () { go(1); });
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    $('[data-reel-toggle]', viewer).addEventListener('click', function () {
      if (video.paused) playSafe(video); else video.pause();
    });
    soundBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      wantSound = !video.muted;
      syncSound();
      if (video.paused) playSafe(video);
    });
    $$('[data-reel-close]', viewer).forEach(function (b) { b.addEventListener('click', close); });
    // Adding to cart from the viewer: close it so the cart drawer is visible.
    viewer.addEventListener('submit', function (e) {
      if (e.target.closest('[data-reel-add]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (viewer.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') go(1);
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') go(-1);
    });
    // Swipe up / left for the next video, down / right for the previous one.
    var startX = 0, startY = 0;
    stage.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 50) return;
      if (Math.abs(dy) > Math.abs(dx)) go(dy < 0 ? 1 : -1);
      else go(dx < 0 ? 1 : -1);
    }, { passive: true });
  });

  /* ---------- Category mosaic: tiles rise in on scroll, videos play in view ---------- */
  if ('IntersectionObserver' in window) {
    $$('[data-mosaic]').forEach(function (sec) {
      sec.classList.add('is-ready');
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        sec.classList.add('is-visible');
        io.disconnect();
      }, { threshold: 0.12 });
      io.observe(sec);
    });
    var mosaicVideos = $$('.mosaic__video');
    if (mosaicVideos.length) {
      var mvObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playSafe(entry.target); else entry.target.pause();
        });
      }, { threshold: 0.3 });
      mosaicVideos.forEach(function (v) { v.muted = true; mvObserver.observe(v); });
    }
  }

  /* ---------- Offer countdown ---------- */
  $$('[data-countdown]').forEach(function (bar) {
    // "2026-11-01T23:59:00+0530" -> "+05:30" so every browser parses it
    var end = new Date(String(bar.dataset.end || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2')).getTime();
    if (isNaN(end)) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { bar.hidden = true; clearInterval(timer); return; }
      var set = function (k, v) { var el = $('[data-cd="' + k + '"]', bar); if (el) el.textContent = pad(v); };
      set('d', Math.floor(left / 86400));
      set('h', Math.floor(left % 86400 / 3600));
      set('m', Math.floor(left % 3600 / 60));
      set('s', left % 60);
    }
    var timer = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Gift finder ---------- */
  $$('[data-gift-finder]').forEach(function (sec) {
    var chosen = '';
    var budgets = $('[data-gift-budgets]', sec);
    $$('[data-gift-person]', sec).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        chosen = a.dataset.url;
        $$('[data-gift-person]', sec).forEach(function (x) { x.classList.toggle('is-active', x === a); });
        budgets.hidden = false;
        budgets.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
    $$('[data-gift-budget]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!chosen) return;
        var params = new URLSearchParams();
        if (b.dataset.min) params.set('filter.v.price.gte', b.dataset.min);
        if (b.dataset.max) params.set('filter.v.price.lte', b.dataset.max);
        var q = params.toString();
        window.location.href = chosen + (q ? (chosen.indexOf('?') > -1 ? '&' : '?') + q : '');
      });
    });
  });

  /* ---------- Welcome popup (once per visitor) ---------- */
  $$('[data-welcome-popup]').forEach(function (popup) {
    var KEY = popup.dataset.key || 'stj_popup_seen';
    var preview = popup.dataset.preview === 'true';
    var justSubscribed = !!$('.form-success', popup);
    var seen = false;
    try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
    function open() {
      popup.hidden = false;
      try { sessionStorage.setItem('stj_popup_shown', '1'); } catch (e) {} // Silver Sakhi skips its hint this visit
    }
    function close() {
      popup.hidden = true;
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    }
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target.closest('[data-popup-close-link]')) {
        if (e.target.closest('[data-popup-close]')) e.preventDefault();
        close();
      }
      var copy = e.target.closest('[data-copy-code]');
      if (copy) {
        var code = $('[data-popup-code]', popup).textContent.trim();
        var done = function () { copy.textContent = 'Copied!'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
    if (justSubscribed || preview) { open(); return; }
    if (!seen) setTimeout(open, (parseInt(popup.dataset.delay, 10) || 0) * 1000);
  });

  /* ---------- Store pickup notice (all visitors or only local pincodes) ---------- */
  $$('[data-store-pickup]').forEach(function (box) {
    if (box.dataset.mode === 'everyone') return;
    var prefixes = String(box.dataset.prefixes || '').split(/[\s,]+/).filter(Boolean);
    function check(pin) {
      box.hidden = !(pin && prefixes.some(function (p) { return String(pin).indexOf(p) === 0; }));
    }
    try { check(localStorage.getItem('stj_pincode')); } catch (e) {}
    document.addEventListener('stj:pincode', function (e) { check(e.detail.pincode); });
  });

  /* ---------- Complete the look: "Buy all" adds this design + the set pieces.
     With a set discount on, the code is applied (/discount/CODE) before adding,
     so it is ready at checkout. Totals follow the chosen size. ---------- */
  $$('[data-complete-set]').forEach(function (box) {
    var btn = $('[data-set-add]', box);
    var section = box.closest('[data-product-section]');
    if (!btn) return;
    var code = box.dataset.discount || '';
    var percent = Number(box.dataset.percent || 0);
    var cur = $('[data-set-current-price]', box);
    var curMrp = $('[data-set-current-mrp]', box);
    function recalc() {
      var total = 0, mrp = 0;
      $$('[data-set-price]', box).forEach(function (el) {
        var p = Number(el.dataset.setPrice || 0), m = Number(el.dataset.setMrpValue || 0);
        total += p; mrp += Math.max(m, p);
      });
      var pay = percent ? Math.round((total - total * percent / 100) / 100) * 100 : total;
      var t = $('[data-set-total]', box), mEl = $('[data-set-mrp]', box);
      if (t) t.textContent = formatMoney(pay).replace(/\.00$/, '');
      if (mEl) { mEl.hidden = !(mrp > pay); mEl.textContent = 'MRP ' + formatMoney(mrp).replace(/\.00$/, ''); }
    }
    if (section) section.addEventListener('stj:variant', function (e) {
      var v = e.detail || {};
      if (!cur) return;
      cur.dataset.setPrice = v.price;
      cur.dataset.setMrpValue = v.compare_at_price || v.price;
      cur.textContent = formatMoney(v.price).replace(/\.00$/, '');
      if (curMrp) { var sale = v.compare_at_price > v.price; curMrp.hidden = !sale; if (sale) curMrp.textContent = formatMoney(v.compare_at_price).replace(/\.00$/, ''); }
      btn.disabled = v.available === false;
      recalc();
    });
    btn.addEventListener('click', function () {
      var idInput = section && $('[data-variant-id]', section);
      var items = [];
      if (idInput && idInput.value) items.push({ id: Number(idInput.value), quantity: 1 });
      $$('[data-set-variant]', box).forEach(function (el) { items.push({ id: Number(el.dataset.setVariant), quantity: 1 }); });
      if (!items.length) return;
      btn.disabled = true;
      var applyCode = code ? fetch((T.routes.root || '/').replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      applyCode
        .then(function () {
          return fetch(T.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: window.location.pathname })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status >= 400) { toast(res.description || res.message || 'Could not add the set'); return; }
          if (code) toast('Set discount ' + code + ' will be applied at checkout');
          return refreshCart(res.sections).then(function () { openDrawer('CartDrawer'); });
        })
        .catch(function () { toast('Could not add the set. Please try again.'); })
        .finally(function () { btn.disabled = false; });
    });
  });

  /* ---------- Ring size finder ----------
     Indian size n has circumference ≈ 48.0 mm + (n − 6) × 1.0167 mm. */
  $$('[data-ring-finder]').forEach(function (root) {
    var CARD_MM = 85.6;
    function circOf(size) { return 48.0 + (size - 6) * 1.0167; }
    function sizeOfCirc(c) { return Math.round((c - 48.0) / 1.0167 + 6); }
    function resultHtml(circ) {
      var size = sizeOfCirc(circ);
      if (size < 1 || size > 30) return '<p class="small accent">That measurement looks outside ring sizes (1–30). Please measure again.</p>';
      return '<p class="ring-result__label">Your Indian ring size</p><p class="ring-result__size">' + size + '</p>' +
        '<p class="small muted">Inside diameter ' + (circ / Math.PI).toFixed(1) + ' mm · circumference ' + circ.toFixed(1) + ' mm</p>';
    }

    var chart = $('[data-ring-chart]', root);
    if (chart) {
      var rows = '';
      for (var s = 1; s <= 30; s++) {
        var c = circOf(s);
        rows += '<tr><td>' + s + '</td><td>' + (c / Math.PI).toFixed(1) + '</td><td>' + c.toFixed(1) + '</td></tr>';
      }
      chart.innerHTML = rows;
    }

    var thread = $('[data-ring-thread]', root);
    var threadOut = $('[data-ring-result-thread]', root);
    if (thread && threadOut) {
      thread.addEventListener('input', function () {
        var v = parseFloat(thread.value);
        threadOut.innerHTML = v > 0 ? resultHtml(v) : '';
      });
    }

    var COIN_MM = 27; // ₹10 coin diameter
    var coin = $('[data-ring-coin]', root);
    var coinRange = $('[data-ring-coin-range]', root);
    var circle = $('[data-ring-circle]', root);
    var circleRange = $('[data-ring-circle-range]', root);
    var screenOut = $('[data-ring-result-screen]', root);
    var stepCal = $('[data-ring-step="calibrate"]', root);
    var stepMeasure = $('[data-ring-step="measure"]', root);
    if (!coin || !coinRange || !circle || !circleRange) return;
    var pxPerMm = 0;
    try { pxPerMm = parseFloat(localStorage.getItem('stj_ring_px_per_mm')) || 0; } catch (e) {}
    if (pxPerMm) coinRange.value = Math.round(pxPerMm * COIN_MM);

    function drawCoin() {
      coin.style.width = coin.style.height = coinRange.value + 'px';
    }
    function drawCircle() {
      var d = parseFloat(circleRange.value);
      circle.style.width = circle.style.height = (d * pxPerMm) + 'px';
      if (screenOut) screenOut.innerHTML = resultHtml(d * Math.PI);
    }
    function show(measure) {
      stepCal.hidden = measure;
      stepMeasure.hidden = !measure;
      if (measure) drawCircle(); else drawCoin();
    }
    coinRange.addEventListener('input', drawCoin);
    circleRange.addEventListener('input', drawCircle);
    $$('[data-ring-step-btn]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var range = btn.dataset.ringStepBtn === 'coin' ? coinRange : circleRange;
        var v = Math.min(parseFloat(range.max), Math.max(parseFloat(range.min), parseFloat(range.value) + parseFloat(btn.dataset.delta)));
        range.value = Math.round(v * 100) / 100;
        range.dispatchEvent(new Event('input'));
      });
    });
    $('[data-ring-calibrated]', root).addEventListener('click', function () {
      pxPerMm = parseFloat(coinRange.value) / COIN_MM;
      try { localStorage.setItem('stj_ring_px_per_mm', String(pxPerMm)); } catch (e) {}
      show(true);
    });
    $('[data-ring-recalibrate]', root).addEventListener('click', function () { show(false); });
    show(!!pxPerMm);
  });

  /* ---------- Track order: open the courier tracking page ---------- */
  $$('[data-track-form]').forEach(function (form) {
    var error = $('[data-track-error]', form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var number = form.elements.number.value.replace(/\s+/g, '').replace(/^#/, '');
      if (error) error.hidden = !!number;
      if (!number) return;
      var url = form.dataset.url || '';
      if (url.indexOf('{number}') === -1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'awb=';
      window.open(url.indexOf('{number}') === -1 ? url + encodeURIComponent(number) : url.replace('{number}', encodeURIComponent(number)), '_blank', 'noopener');
    });
  });

  /* ---------- Copy a code ([data-copy]) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy]');
    if (!btn || !btn.dataset.copy) return;
    var done = function () { btn.textContent = 'Copied!'; };
    if (navigator.clipboard) navigator.clipboard.writeText(btn.dataset.copy).then(done, done); else done();
  });

  /* ---------- Spin the wheel ---------- */
  $$('[data-spin]').forEach(function (root) {
    var prizes = [];
    try { prizes = JSON.parse($('[data-spin-prizes]', root).textContent); } catch (e) { return; }
    if (prizes.length < 2) return;
    var wheel = $('[data-spin-wheel]', root);
    var form = $('[data-spin-form]', root);
    var result = $('[data-spin-result]', root);
    var key = root.dataset.key;
    var seg = 360 / prizes.length;
    var NS = 'http://www.w3.org/2000/svg';

    function pt(angle, r) {
      var a = (angle - 90) * Math.PI / 180;
      return (r * Math.cos(a)).toFixed(2) + ' ' + (r * Math.sin(a)).toFixed(2);
    }
    function textColor(hex) {
      var h = String(hex || '').replace('#', '');
      if (h.length !== 6) return '#fff';
      var l = 0.299 * parseInt(h.substr(0, 2), 16) + 0.587 * parseInt(h.substr(2, 2), 16) + 0.114 * parseInt(h.substr(4, 2), 16);
      return l > 160 ? '#2b2b2b' : '#fff';
    }
    prizes.forEach(function (p, i) {
      var start = i * seg, end = start + seg, mid = start + seg / 2;
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('d', 'M0 0 L' + pt(start, 100) + ' A100 100 0 ' + (seg > 180 ? 1 : 0) + ' 1 ' + pt(end, 100) + ' Z');
      path.setAttribute('fill', p.color || '#5B2A3E');
      path.setAttribute('stroke', '#fff');
      path.setAttribute('stroke-width', '2');
      wheel.appendChild(path);
      var text = document.createElementNS(NS, 'text');
      text.setAttribute('transform', 'rotate(' + mid + ') translate(0 -62) rotate(90)');
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('dominant-baseline', 'middle');
      text.setAttribute('font-size', p.label.length > 10 ? '9' : '11');
      text.setAttribute('font-weight', '700');
      text.setAttribute('fill', textColor(p.color));
      text.textContent = p.label;
      wheel.appendChild(text);
    });
    var rim = document.createElementNS(NS, 'circle');
    rim.setAttribute('r', '103'); rim.setAttribute('fill', 'none'); rim.setAttribute('stroke', '#EBDCDA'); rim.setAttribute('stroke-width', '6');
    wheel.appendChild(rim);

    function show(index, animate) {
      var p = prizes[index];
      var target = 360 * 6 - (index * seg + seg / 2) + (Math.random() - 0.5) * seg * 0.5;
      if (!animate) { wheel.style.transition = 'none'; target = 360 - (index * seg + seg / 2); }
      wheel.style.transform = 'rotate(' + target + 'deg)';
      var reveal = function () {
        $('[data-spin-prize]', result).textContent = p.label;
        $('[data-spin-note]', result).textContent = p.note || '';
        var wrap = $('[data-spin-code-wrap]', result);
        wrap.hidden = !p.code;
        if (p.code) {
          $('[data-spin-code]', result).textContent = p.code;
          $('[data-copy]', result).dataset.copy = p.code;
        }
        form.hidden = true;
        result.hidden = false;
        // Welcome popup: put the won code on the cart so it is ready at checkout
        if (animate && p.code && root.dataset.autoapply === 'true') {
          fetch(rootUrl + 'discount/' + encodeURIComponent(p.code) + '?redirect=' + encodeURIComponent(rootUrl + 'cart.js'), { credentials: 'same-origin' })
            .then(function () { var ap = $('[data-spin-applied]', result); if (ap) ap.hidden = false; })
            .catch(function () {});
        }
      };
      if (animate) setTimeout(reveal, 4700); else reveal();
    }

    if (root.dataset.once === 'true') {
      try {
        var saved = JSON.parse(localStorage.getItem(key) || 'null');
        if (saved && prizes[saved.index] && prizes[saved.index].label === saved.label) { show(saved.index, false); return; }
      } catch (e) {}
    }

    var phoneIn = $('[data-spin-phone]', form);
    var phoneErr = $('[data-spin-error]', form);
    function cleanPhone(v) {
      var d = String(v || '').replace(/\D/g, '');
      if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
      if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
      return /^[6-9]\d{9}$/.test(d) ? d : '';
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var phone = '';
      if (phoneIn) {
        phone = cleanPhone(phoneIn.value);
        if (phoneErr) phoneErr.hidden = !!phone;
        if (!phone) { phoneIn.focus(); return; }
      }
      if (!form.reportValidity()) return;
      var total = prizes.reduce(function (s, p) { return s + (Number(p.chance) || 1); }, 0);
      var r = Math.random() * total, index = 0;
      for (var i = 0; i < prizes.length; i++) {
        r -= Number(prizes[i].chance) || 1;
        if (r < 0) { index = i; break; }
      }
      var prizeTag = 'prize-' + prizes[index].label.toLowerCase().replace(/₹/g, 'rs').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      $('[data-spin-tags]', form).value = (root.dataset.tag ? root.dataset.tag + ',' : '') + prizeTag;
      $('[data-spin-button]', form).disabled = true;
      fetch(form.action, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams(new FormData(form)).toString(), credentials: 'same-origin' }).catch(function () {});
      try { localStorage.setItem(key, JSON.stringify({ index: index, label: prizes[index].label })); } catch (err) {}
      // Staff Portal CRM lead (assets/crm-capture.js)
      if (window.stjCrmLead) {
        var crmName = form.querySelector('[name="contact[first_name]"]'), crmEmail = form.querySelector('[name="contact[email]"]');
        window.stjCrmLead({ form: 'Spin & win', name: crmName ? crmName.value.trim() : '', email: crmEmail ? crmEmail.value.trim() : '', mobile: phone,
          extra: { Prize: prizes[index].label + (prizes[index].code ? ' (' + prizes[index].code + ')' : '') } });
      }
      if (root.dataset.lead === 'true') {
        // Mobile number + prize go to the store email (customer records keep name, email and tags)
        var fd = new FormData();
        var nameIn = form.querySelector('[name="contact[first_name]"]');
        var emailIn = form.querySelector('[name="contact[email]"]');
        fd.append('form_type', 'contact');
        fd.append('utf8', '\u2713');
        fd.append('contact[name]', nameIn ? nameIn.value : '');
        fd.append('contact[email]', emailIn ? emailIn.value : '');
        if (phone) fd.append('contact[phone]', '+91 ' + phone);
        fd.append('contact[body]', 'Spin & win (welcome popup)\nPrize: ' + prizes[index].label + (prizes[index].code ? ' (' + prizes[index].code + ')' : '') + '\nMobile: +91 ' + phone);
        fetch(rootUrl + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
        try { var wp = root.closest('[data-welcome-popup]'); localStorage.setItem((wp && wp.dataset.key) || 'stj_popup_seen', '1'); } catch (err) {}
      }
      show(index, true);
    });
  });

  /* ---------- Savings Plan: calculator, enrolment + certificate ----------
     On submit we add a Plan Number, end month and plan value (they are
     emailed with the form) and keep the answers for this tab. After Shopify
     reloads with the success message we show the certificate, save the member
     in Customers (tags) and fill the WhatsApp / pay links. */
  var SP_KEY = 'stj_savings_enrol';
  function spMoney(n) { return '₹' + Number(n).toLocaleString('en-IN'); }
  function spMonth(d) { return d.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' }); }
  $$('[data-savings-plan]').forEach(function (root) {
    var paid = parseInt(root.dataset.paid, 10) || 10;
    var bonus = parseInt(root.dataset.bonus, 10) || 1;
    var chips = $$('[data-sp-amount]', root);
    var select = $('[data-sp-select]', root);
    function setAmount(a) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(Number(c.dataset.spAmount) === a)); });
      var put = function (k, v) { var el = $('[data-sp="' + k + '"]', root); if (el) el.textContent = v; };
      put('monthly', spMoney(a));
      put('paid', spMoney(a * paid));
      put('bonus', '+ ' + spMoney(a * bonus));
      put('total', spMoney(a * (paid + bonus)));
      if (select) $$('option', select).forEach(function (o) { if (Number(o.dataset.amount) === a) o.selected = true; });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { setAmount(Number(c.dataset.spAmount)); }); });
    if (select) select.addEventListener('change', function () { setAmount(Number(select.selectedOptions[0].dataset.amount)); });
    var pressed = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || chips[0];
    if (pressed) setAmount(Number(pressed.dataset.spAmount));

    // First instalment month: this month (until the 20th) and the next two.
    var start = $('[data-sp-start]', root);
    if (start) {
      var now = new Date();
      var first = new Date(now.getFullYear(), now.getMonth() + (now.getDate() > 20 ? 1 : 0), 1);
      for (var i = 0; i < 3; i++) {
        var d = new Date(first.getFullYear(), first.getMonth() + i, 1);
        var o = document.createElement('option');
        o.value = spMonth(d);
        o.textContent = spMonth(d);
        o.dataset.y = d.getFullYear(); o.dataset.m = d.getMonth();
        start.appendChild(o);
      }
    }

    var form = $('form[data-sp-form]', root);
    if (form && start) {
      form.addEventListener('submit', function () {
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var now = new Date();
        var planNo = 'STJ-SP-' + String(now.getFullYear()).slice(2) + pad(now.getMonth() + 1) + '-' + Math.floor(1000 + Math.random() * 9000);
        var so = start.selectedOptions[0];
        var end = new Date(Number(so.dataset.y), Number(so.dataset.m) + paid, 1);
        var amount = Number(select.selectedOptions[0].dataset.amount);
        $('[data-sp-plan-input]', form).value = planNo;
        $('[data-sp-end-input]', form).value = spMonth(end);
        $('[data-sp-value-input]', form).value = spMoney(amount * (paid + bonus));
        var rows = [];
        $$('[data-sp-field]', form).forEach(function (el) {
          if (el.dataset.spField === 'PAN') el.value = el.value.trim().toUpperCase();
          var v = String(el.value || '').trim();
          if (v) rows.push([el.dataset.spField, v]);
        });
        rows.push(['Plan completes', spMonth(end)]);
        rows.push(['Jewellery value', spMoney(amount * (paid + bonus))]);
        try {
          sessionStorage.setItem(SP_KEY, JSON.stringify({
            plan: planNo, amount: amount, rows: rows, at: Date.now(),
            email: form.elements['contact[email]'].value, name: form.elements['contact[name]'].value,
            phone: form.elements['contact[phone]'].value, city: form.elements['contact[City]'] ? form.elements['contact[City]'].value : ''
          }));
        } catch (e) {}
      });
    }

    var done = $('[data-sp-done]', root);
    if (!done) return;
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem(SP_KEY) || 'null'); } catch (e) {}
    if (!data || !data.plan || Date.now() - data.at > 3600000) return;
    $('[data-sp-cert-no]', done).textContent = data.plan;
    var tbody = $('[data-sp-cert-rows]', done);
    data.rows.forEach(function (row) {
      if (row[0] === 'Email' || row[0] === 'City' || row[0] === 'PAN') return;
      var tr = document.createElement('tr');
      var th = document.createElement('th'); th.textContent = row[0];
      var td = document.createElement('td'); td.textContent = row[1];
      tr.appendChild(th); tr.appendChild(td); tbody.appendChild(tr);
    });
    $$('[data-sp-cert]', done).forEach(function (el) { el.hidden = false; });
    try { localStorage.setItem('stj_sp_plan', JSON.stringify({ plan: data.plan, amount: data.amount, name: data.name, email: data.email, phone: data.phone, city: data.city })); } catch (e) {}

    var pay = $('[data-sp-pay]', done);
    if (pay) pay.href = pay.getAttribute('href').split('?')[0] + '?plan=' + encodeURIComponent(data.plan) + '&amount=' + data.amount + '&inst=1';
    var wa = $('[data-sp-whatsapp]', done);
    if (wa && done.dataset.number) {
      var lines = ['*Savings Plan enrolment*', '', 'Plan Number: ' + data.plan];
      data.rows.forEach(function (row) {
        var v = row[0] === 'PAN' ? String(row[1]).slice(0, 2) + '******' + String(row[1]).slice(-2) : row[1];
        lines.push(row[0] + ': ' + v);
      });
      wa.href = 'https://wa.me/' + done.dataset.number + '?text=' + encodeURIComponent(lines.join('\n'));
    }

    // Save the member in Customers with the tags savings-plan + Plan Number (once).
    var cust = $('form[data-sp-customer]', root);
    if (cust && data.email && !data.saved) {
      cust.elements['contact[email]'].value = data.email;
      cust.elements['contact[first_name]'].value = data.name || '';
      cust.elements['contact[tags]'].value = 'savings-plan,' + data.plan + ',sp-amount-' + data.amount + ',kyc-pending';
      fetch(cust.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(cust)).toString(),
        credentials: 'same-origin'
      }).catch(function () {});
      data.saved = true;
      try { sessionStorage.setItem(SP_KEY, JSON.stringify(data)); } catch (e) {}
    }
    done.scrollIntoView({ block: 'start' });
  });

  /* ---------- Savings Plan: instalment payment page ----------
     The plan amount is fixed when we know it (signed-in member tags, the link,
     or this browser's enrolment); only then is the amount choice hidden.
     Paying replaces any instalment already in the cart, so the cart always
     holds exactly one instalment, then goes straight to checkout. */
  $$('[data-sp-pay-section]').forEach(function (root) {
    var form = $('form[data-sp-pay-form]', root);
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem('stj_sp_plan') || '{}') || {}; } catch (e) {}
    var plan = $('[data-sp-plan]', form);
    var member = $('[data-sp-member]', form);
    var inst = $('[data-sp-inst]', form);
    var email = $('[data-sp-email]', form);
    var phone = $('[data-sp-phone]', form);
    var city = $('[data-sp-city]', form);
    var button = $('[data-sp-pay-button]', form);
    var error = $('[data-sp-pay-error]', form);
    var radios = $$('input[name="id"]', form);

    var memberPlan = form.dataset.memberPlan || '';
    var planValue = params.get('plan') || memberPlan || saved.plan || '';
    if (plan && !plan.value) plan.value = planValue;
    var sameAsSaved = saved.plan && plan && plan.value.toUpperCase() === String(saved.plan).toUpperCase();
    if (sameAsSaved) {
      if (member && !member.value && saved.name) member.value = saved.name;
      if (email && !email.value && saved.email) email.value = saved.email;
      if (phone && !phone.value && saved.phone) phone.value = saved.phone;
      if (city && saved.city) city.value = saved.city;
    }
    if (inst && params.get('inst')) {
      $$('option', inst).forEach(function (o) { if (o.value.split(' ')[0] === params.get('inst')) o.selected = true; });
    }

    // Fix the amount when we know the plan's amount.
    var fixedAmount = Number(form.dataset.memberAmount || 0) || Number(params.get('amount') || 0) || (sameAsSaved ? Number(saved.amount || 0) : 0);
    var match = radios.filter(function (r) { return Number(r.dataset.price) === fixedAmount && !r.disabled; })[0];
    if (match) {
      match.checked = true;
      var fixedBox = $('[data-sp-fixed]', form);
      $('[data-sp-fixed-amount]', form).textContent = spMoney(fixedAmount);
      fixedBox.hidden = false;
      $('[data-sp-choose]', form).hidden = true;
    }
    var label = $('[data-sp-pay-amount]', form);
    function checkedRadio() { return radios.filter(function (x) { return x.checked; })[0]; }
    function syncAmount() { var r = checkedRadio(); if (r && label) label.textContent = spMoney(r.dataset.price); }
    radios.forEach(function (r) { r.addEventListener('change', syncAmount); });
    syncAmount();

    function checkoutUrl(info) {
      var ret = $('[data-sp-return]', form);
      var base = (ret ? ret.value : '/checkout').split('?')[0];
      var q = [];
      var add = function (k, v) { if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); };
      var parts = info.name.split(/\s+/);
      add('checkout[email]', info.email);
      add('checkout[shipping_address][first_name]', parts.length > 1 ? parts.slice(0, -1).join(' ') : parts[0]);
      add('checkout[shipping_address][last_name]', parts.length > 1 ? parts[parts.length - 1] : '');
      add('checkout[shipping_address][phone]', info.phone);
      add('checkout[shipping_address][city]', info.city);
      return q.length ? base + '?' + q.join('&') : base;
    }

    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!form.reportValidity()) return;
      var r = checkedRadio();
      if (!r) return;
      if (plan) plan.value = plan.value.trim().toUpperCase();
      var info = {
        plan: plan ? plan.value : '', amount: Number(r.dataset.price),
        name: member ? member.value.trim() : '', email: email ? email.value.trim() : '',
        phone: phone ? phone.value.trim() : '', city: city ? city.value.trim() : ''
      };
      try { localStorage.setItem('stj_sp_plan', JSON.stringify(info)); } catch (err) {}
      busy = true;
      if (button) { button.disabled = true; button.dataset.label = button.innerHTML; button.textContent = 'Please wait…'; }
      if (error) error.hidden = true;
      var properties = {};
      $$('[name^="properties["]', form).forEach(function (el) {
        if (el.value) properties[el.name.slice(11, -1)] = el.value;
      });
      fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // Remove any instalment already in the cart (double clicks, earlier attempts).
          var updates = {};
          (cart.items || []).forEach(function (item) {
            var isInstalment = (item.properties && item.properties['Plan Number']) || radios.some(function (x) { return Number(x.value) === item.variant_id; });
            if (isInstalment) updates[item.key] = 0;
          });
          if (!Object.keys(updates).length) return null;
          return fetch(T.routes.cart + '/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function () {
          return fetch(T.routes.cartAdd + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1, properties: properties }] })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add');
          window.location.href = checkoutUrl(info);
        })
        .catch(function () {
          busy = false;
          if (button) { button.disabled = false; button.innerHTML = button.dataset.label; }
          if (error) { error.textContent = 'Could not start the payment. Please try again or contact us on WhatsApp.'; error.hidden = false; }
        });
    });
  });

  /* ---------- Shop the look: dots highlight the matching product; quick add ---------- */
  $$('[data-look]').forEach(function (look) {
    function select(i) {
      $$('[data-look-dot]', look).forEach(function (d) { d.classList.toggle('is-active', d.dataset.lookDot === String(i)); });
      $$('[data-look-item]', look).forEach(function (it) {
        var on = it.dataset.lookItem === String(i);
        it.classList.toggle('is-active', on);
        if (on && window.matchMedia('(max-width: 989px)').matches) it.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
    look.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-look-dot]');
      if (dot) { select(dot.dataset.lookDot); return; }
      var add = e.target.closest('[data-look-add]');
      if (!add) return;
      add.disabled = true;
      fetch(T.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.lookAdd), quantity: 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status >= 400) { toast(res.description || 'Could not add to cart'); return; }
          return refreshCart(res.sections).then(function () { openDrawer('CartDrawer'); });
        })
        .catch(function () { toast('Could not add to cart. Please try again.'); })
        .finally(function () { add.disabled = false; });
    });
    $$('[data-look-item]', look).forEach(function (it) {
      it.addEventListener('mouseenter', function () { select(it.dataset.lookItem); });
    });
  });

  /* ---------- Silver coins: filter by weight ---------- */
  $$('[data-coin-filter]').forEach(function (bar) {
    var section = bar.closest('section');
    var items = $$('[data-coin-grid] > li', section);
    var empty = $('[data-coin-empty]', section);
    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-coin-weight]');
      if (!chip) return;
      var w = chip.dataset.coinWeight;
      $$('[data-coin-weight]', bar).forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
      var shown = 0;
      items.forEach(function (li) {
        var on = w === 'all' || li.dataset.weight === w;
        li.hidden = !on;
        if (on) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  });

  /* ---------- Footer: menus collapsed on mobile, open on larger screens ---------- */
  (function () {
    var accs = $$('[data-footer-acc]');
    if (!accs.length) return;
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() { accs.forEach(function (d) { d.open = mq.matches || d.hasAttribute('data-footer-keep-open'); }); }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  })();

  /* Shared with assistant.js */
  window.STJ = { fetchCards: fetchCards, formatMoney: formatMoney, toast: toast, syncWishlistUI: syncWishlistUI };

  /* ---------- Init ---------- */
  setHeaderHeight();
  $$('[data-product-section]').forEach(initProduct);
  trackRecentlyViewed();
  syncWishlistUI();
  renderWishlistPage();
  renderRecentlyViewed();
})();
